import { ResponsiveAppScreenshot } from "@/components/marketing/ResponsiveAppScreenshot"
import {
  FeatureThreeColumnWithDemos,
  Features,
} from "@/components/marketing/sections/features-three-column-with-demos"
import { AUDIENCE_FEATURES } from "@/content/marketing/site-content"

const WALLPAPERS = ["purple", "blue", "brown", "green"] as const

export function MarketingAudienceSection() {
  return (
    <Features
      id="audiences"
      eyebrow="Who it's for"
      headline="One spec, different jobs for each role"
      subheadline={
        <p>
          Every scenario is written once, in the app. Product owners and stakeholders read it in Explore, developers
          and builders author it there too, and QA tracks whether reality still fits it.
        </p>
      }
      featured={
        <FeatureThreeColumnWithDemos
          key={AUDIENCE_FEATURES[0].headline}
          featured
          headline={AUDIENCE_FEATURES[0].headline}
          subheadline={<p>{AUDIENCE_FEATURES[0].subheadline}</p>}
          demo={
            <ResponsiveAppScreenshot
              shot={AUDIENCE_FEATURES[0].shot}
              wallpaper={WALLPAPERS[0]}
              placement="bottom"
            />
          }
        />
      }
      features={
        <>
          {AUDIENCE_FEATURES.slice(1).map((item, i) => (
            <FeatureThreeColumnWithDemos
              key={item.headline}
              headline={item.headline}
              subheadline={<p>{item.subheadline}</p>}
              demo={
                <ResponsiveAppScreenshot
                  shot={item.shot}
                  wallpaper={WALLPAPERS[(i + 1) % WALLPAPERS.length]}
                  placement="bottom"
                />
              }
            />
          ))}
        </>
      }
    />
  )
}
